import Emitter from "./Emitter";
import { constants } from "../../constants";

export default class GameSpinEnd extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: 'gameCompleted' });

        if (this.gb.gameProviderProtocol && this.gb.gameProviderProtocol !== constants.EVOLUTION) {
            this.emitParent({ event: 'keepAlive' });
        }
    }

    IGT_handler() {
        this.emitParent({ event: 'gameCompleted' });
        this.emitParent({ event: 'keepAlive' });
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_complete", balance: data });
            this.emitParent({ event: "round_complete", balance: data });
        } else {
            this.emitTop({ event: "round_complete"});
            this.emitParent({ event: "round_complete" });
        }
    }

    BWIN_handler() {
        this.emitParent("round_complete")
        this.emitTop("round_complete")
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({ idle:true }));
        this.emitTop("GAMEROUND_ENDED");
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('gameround')) {
            let data = {_type: "ucip.gameround.g2wGameRoundEndNotification"}
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
            
            } else {
                this.emitParent(JSON.stringify(data));
               
            }
        }
    }

    MGS_handler() {
        this.emitParent('{"Name" : "idle", "Origin" : "embeddedgame"}');
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId":"rg2xcGameStatusUpdated",
            "status": "handEnd",
        }

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcGameResultShown"}), this.gb.api.settings.pokerstarsOrigin);
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcGameResultShown"}), "*");
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    LNWOGS_handler(data) {
        this.gb.wallet.gameSpinEnd();
    }

    _default(msg) {
        const data = msg ? { wpgaction: "gameSpinEnd", data: msg } : { wpgaction: "gameSpinEnd" };
        const dataParent = msg ? { wpgaction: "gameSpinEnd.parent", data: msg } : { wpgaction: "gameSpinEnd.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
